import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import { mapUrl } from '../../../../logic/main/utils';
import { DeviceContext } from '../../../../components/DeviceProvider/DeviceProvider';
import { ShouldPreventDefaultForClick } from '../../../../components/LaunchStrategiesProvider/utils';
import { GameDetailsTopPropTypes } from '../GameDetailsTop';
import { GameMode } from '../../../../types/gameTypes';

interface GamePracticeLinkPropTypes {
  game: GameTileProps;
  practiveButtonText?: string;
  pageTitle?: string;
  onGameClick: GameDetailsTopPropTypes['onGameButtonClick'];
}

const GamePracticeLink: React.FC<GamePracticeLinkPropTypes> = React.memo(
  ({ game, practiveButtonText, pageTitle, onGameClick }) => {
    const { deviceType, deviceOs } = React.useContext(DeviceContext);
    if (!game.practiceUrl) return null;

    const preventDefaultForGameClick = ShouldPreventDefaultForClick(
      game.integration
    );

    const gameLink = mapUrl(game.practiceUrl, deviceType, deviceOs, {
      title: 'game_details',
      topCategory: pageTitle,
    });

    const handleGameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefaultForGameClick) e.preventDefault();
      onGameClick &&
        onGameClick({
          game: game,
          gamePosition: 1,
          sectionTitle: 'Game Details',
          gameMode: GameMode.Practice,
        });
    };

    return (
      <a
        className={cx(styles.link, styles.linkHollow, styles.headerLink)}
        data-testid="game-details-header-practice-button"
        target="_blank"
        rel={`noopener noreferrer ${game.notIndexed ? 'nofollow' : ''}`}
        href={gameLink}
        onClick={handleGameClick}
      >
        {practiveButtonText}
      </a>
    );
  },
  (
    prevProps: GamePracticeLinkPropTypes,
    nextProps: GamePracticeLinkPropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GamePracticeLink;
